import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class UserShowModel extends ApiModel {
  static get path() {
    return '/backend/user_shows/{?id}';
  }

  @computed
  get showIri(): string {
    return this.get('show.@id');
  }

  @computed
  get userId(): id {
    return this.get('user.id');
  }
}
